import type { AttachedDocument } from "adl-gen/ferovinum/app/uploads";
import { useContext } from "react";
import { isAdmin } from "utils/user-utils";
import type { DocumentDownloaderButtonProps } from "../../../../packages/components/widgets/buttons/document-downloader";
import { LoggedInContext } from "../app/app";
import { useAdminUIRootRoute } from "./use-admin-ui-root-route";
import { useAppService } from "./use-app-service";

/*  Note:  There is a copy of this in  admin-portal/src/hooks/use-document-downloader-props.
    Noah said to make a copy for now and  he will refactor later.   Oct-11-2024
*/

export function useDocumentDownloaderProps(
  attachedDocuments: AttachedDocument[],
): DocumentDownloaderButtonProps {
  const loggedInUserContext = useContext(LoggedInContext);
  const userProfile = loggedInUserContext.loginState?.user?.profile;
  const userIsAdmin = userProfile && isAdmin(userProfile);
  const service = useAppService();
  const appAdminUIHref = useAdminUIRootRoute();

  return {
    attachedDocuments,
    downloadDocument: async (pdf: AttachedDocument) => {
      const getDownloadUrlResp = await service.getDownloadUrl({
        storedFileId: pdf.storedFileId,
      });

      if (getDownloadUrlResp.downloadUrl) {
        window.open(getDownloadUrlResp.downloadUrl, "_blank");
      }
    },
    editGeneratedDocument: userIsAdmin
      ? (pdf: AttachedDocument) => {
          const editUrl = `${appAdminUIHref}/value/invoice/${pdf.invoiceId}`;
          window.open(editUrl, "_blank");
        }
      : undefined,
    generateDocument: userIsAdmin
      ? async (invoiceId: string) => {
          await service.generateInvoicePdf(invoiceId);
        }
      : undefined,
  };
}

/*  Note:  There is a copy of this in  admin-portal/src/hooks/use-document-downloader-props.
    Noah said to make a copy for now and  he will refactor later.   Oct-11-2024
*/
